<template>
  <div class="box">
    <div class="field">
      <label class="label">Add Tickets for All Counter</label>
      <div class="control">
        <input type="number" class="input" v-model="tickets">
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link" type="button" @click="addToAllCounter()">Add to All Counter</button>
      </div>
    </div>
    <div class="field is-grouped is-grouped-right">
      <div class="control">
        <button class="button is-success" type="button" @click="submitData()">Update Data</button>
      </div>
    </div>
    <table class="table is-fullwidth">
      <tr>
        <th>Counter</th>
        <th>Active / Non Active</th>
        <th v-for="(event_row, index) in event_list" :key="index" v-text="event_row.event_title"></th>
      </tr>
      <tr>
        <td>Total Tickets</td>
        <td></td>
        <td v-for="(event_row, index) in event_list" :key="index" v-text="event_row.event_tickets"></td>
      </tr>
      <tr v-for="(counter_row, index) in counter_list" :key="index">
        <td v-text="counter_row.counter_title"></td>
        <td>
          <button v-if="counter_row.active === 0" class="button is-success" type="button" @click="activateCounter(index, 1)">Activate</button>
          <button v-if="counter_row.active === 1" class="button is-danger" type="button" @click="activateCounter(index, 0)">Non Active</button>
        </td>
        <event-service-counter-row v-for="(counter_event_row, index_counter_event) in counter_row.event_service" :key="index_counter_event" :value-row="counter_event_row" :counter-active="counter_row.active" :index-parent="index" :index-counter-event="index_counter_event"></event-service-counter-row>
      </tr>
    </table>
  </div>
</template>

<script>
import EventServiceCounterRow from './components/EventServiceCounterRow'
export default {
  data () {
    return {
      event_list: [],
      counter_list: [],
      tickets: 0,
      event_bus_add_minus_tickets: ''
    }
  },
  components: {
    EventServiceCounterRow
  },
  created () {
    this.getEvent()
    this.getEventServiceCounter()
  },
  mounted () {
    var self = this
    this.event_bus_add_minus_tickets = this.$geb.getFilteredBus({id: 'add-minus-tickets'}).subscribe(eventData => {
      if (eventData.flag === '-') {
        self.counter_list[eventData.index_parent].event_service[0].tickets -= 1
      } else if (eventData.flag === '+') {
        self.counter_list[eventData.index_parent].event_service[0].tickets += 1
      }
    })
  },
  methods: {
    getEvent () {
      var self = this
      self.flyGetSession('head/event_service_counter/event')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.event_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getEventServiceCounter () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/event_service_counter/counter')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.counter_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    addToAllCounter () {
      for (var index in this.counter_list) {
        if (this.counter_list[index].active === 1) {
          this.counter_list[index].event_service[0].tickets += parseInt(this.tickets)
        }
      }
    },
    activateCounter (index, flag) {
      this.counter_list[index].active = flag
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('head/event_service_counter/insert', {
        counter_list: this.counter_list
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.$geb.emit({id: 'alert_modal', title: 'Success!', content: 'Data anda sudah masuk!', button_text: 'OK'})
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  },
  beforeDestroy () {
    if (this.event_bus_add_minus_tickets) {
      this.event_bus_add_minus_tickets.unsubscribe()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/EventServiceCounter.vue